import React, { Component } from 'react';
import { TrackingContext } from './TrackingProvider';

export const withTracking = WrappedComponent => class extends Component {
  static contextType = TrackingContext;

  render() {
    const {
      track,
    } = this.context;

    return (
      <WrappedComponent
        track={track}
        {...this.props}
      />
    );
  }
};


export default withTracking;
